export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS'
export const SIGNUP_USER = 'SIGNUP_USER'
export const INVALIDATE_USER = 'INVALIDATE_USER' // 注销 user
